import React from 'react'
import PropTypes from "prop-types"

import GenericInput from "Components/Generic/GenericInput"

const FilterColumn = ({inputType, inputPlaceholder, column}) => {

  const {filterValue, setFilter} = column

  return (
    <GenericInput 
      onClick="return false"
      value={filterValue || ""}
      type={inputType}
      showIcon={inputType === "text"}
      onChange={(e) => setFilter(e.target.value)}
      inputContainerStyle={{minWidth: "unset", height:"25px", marginTop: "5px"}}
    />
  )
}

FilterColumn.propTypes = {
  inputType: PropTypes.string,
  inputPlaceholder: PropTypes.string,
}

FilterColumn.defaultProps = {
  inputType: "text",
  inputPlaceholder: "",
}

export default FilterColumn
